import { capitalize } from 'lodash'

export const KEY_FORMAT_CAPITALIZE = 'capitalize'

export default capitalize
